import { SxProp, View } from 'dripsy';
import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { ReplaceCardNativeZeroScreen } from './ReplaceCardNativeZero.screen';
import { ReplaceCardNativeOneScreen } from './ReplaceCardNativeOne.screen';
import { ReplaceCardNativeTwoScreen } from './ReplaceCardNativeTwo.screen';
import { ReplaceCardNativeThreeScreen } from './ReplaceCardNativeThree.screen';

export interface ReplaceCardProps {
  onClose: () => void;
}

export const ReplaceCardNativeScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose } = props;
  const { t } = useTranslation('account-management');
  const {} = sxStyles;
  const [step, setStep] = useState('zero');

  if (step == 'zero') return <ReplaceCardNativeZeroScreen onClose={onClose} onStep={(step: string) => setStep(step)} />;
  else if (step == 'one') return <ReplaceCardNativeOneScreen onClose={onClose} onStep={(step: string) => setStep(step)} />;
  else if (step == 'two') return <ReplaceCardNativeTwoScreen onClose={onClose} onStep={(step: string) => setStep(step)} />;
  else if (step == 'three') return <ReplaceCardNativeThreeScreen onClose={onClose} />;
  else return <View></View>;
};
const sxStyles: Record<string, SxProp> = {};
